import { HeaderImageWrapper } from '../styles';
import PropTypes from 'prop-types';
import React from 'react';
import { ThemingContext } from '@doordash/design-language';

var ModalHeaderImage = function ModalHeaderImage(_ref) {
  var headerImage = _ref.headerImage,
      isFullScreenOnMobile = _ref.isFullScreenOnMobile;
  var theme = React.useContext(ThemingContext);
  return /*#__PURE__*/React.createElement(HeaderImageWrapper, {
    isFullScreenOnMobile: isFullScreenOnMobile,
    modalBorderRadius: theme.BorderRadius.ModalDefault
  }, headerImage);
};

ModalHeaderImage.propTypes = {
  headerImage: PropTypes.node,
  isFullScreenOnMobile: PropTypes.bool
};
export default ModalHeaderImage;